export const INFO_CASAS_CITIES: {
  [key: number]: { value: number; label: string }[];
} = {
  10: [
    { value: 1, label: "Buceo" },
    { value: 2, label: "Parque Batlle" },
    { value: 3, label: "Parque Rodó" },
    { value: 4, label: "Pocitos" },
    { value: 5, label: "Pocitos Nuevo" },
    { value: 6, label: "Puerto Buceo" },
    { value: 7, label: "Punta Carretas" },
    { value: 8, label: "Villa Biarritz" },
    { value: 9, label: "Villa Dolores" },
    { value: 10, label: "Bañados de Carrasco" },
    { value: 11, label: "Barra de Carraso" },
    { value: 12, label: "Barrios Privados" },
    { value: 13, label: "Carrasco" },
    { value: 14, label: "Carrasco Este" },
    { value: 15, label: "Carrasco Norte" },
    { value: 16, label: "Malvín" },
    { value: 17, label: "Parque Miramar" },
    { value: 18, label: "Punta Gorda" },
    { value: 19, label: "Aguada" },
    { value: 20, label: "Barrio Sur" },
    { value: 21, label: "Centro" },
    { value: 22, label: "Ciudad Vieja" },
    { value: 23, label: "Cordón" },
    { value: 24, label: "La Comercial" },
    { value: 25, label: "Palermo" },
    { value: 26, label: "Puerto" },
    { value: 27, label: "Tres Cruces" },
    { value: 28, label: "Villa Muñoz" },
    { value: 29, label: "Aires Puros" },
    { value: 30, label: "Arroyo Seco" },
    { value: 31, label: "Atahualpa" },
    { value: 32, label: "Bella Vista" },
    { value: 33, label: "Brazo Oriental" },
    { value: 34, label: "Capurro" },
    { value: 35, label: "Capurro Bella Vista" },
    { value: 36, label: "Cerrito" },
    { value: 37, label: "Goes" },
    { value: 38, label: "Jacinto Vera" },
    { value: 39, label: "Paso Molino" },
    { value: 40, label: "Prado" },
    { value: 41, label: "Prado Nueva Savona" },
    { value: 42, label: "Reducto" },
    { value: 43, label: "Perez Castellanos" },
    { value: 44, label: "La Figurita" },
    { value: 45, label: "Bella Italia" },
    { value: 46, label: "Bolivar" },
    { value: 47, label: "Flor de Maroñas" },
    { value: 48, label: "Ituzaingó" },
    { value: 49, label: "Jardines del Hipódromo" },
    { value: 50, label: "La Blanqueada" },
    { value: 51, label: "Larrañaga" },
    { value: 52, label: "Las Canteras" },
    { value: 53, label: "Malvín Norte" },
    { value: 54, label: "Manga" },
    { value: 55, label: "Maroñas" },
    { value: 56, label: "Mercado Modelo" },
    { value: 57, label: "Piedras Blancas" },
    { value: 58, label: "Punta Rieles" },
    { value: 59, label: "Unión" },
    { value: 60, label: "Villa Española" },
    { value: 61, label: "Villa García Manga Rural" },
    { value: 62, label: "Casavalle" },
    { value: 63, label: "Colón" },
    { value: 64, label: "Conciliación" },
    { value: 65, label: "Las Acacias" },
    { value: 66, label: "Lezica" },
    { value: 67, label: "Melilla" },
    { value: 68, label: "Peñarol" },
    { value: 69, label: "Peñarol Lavalleja" },
    { value: 70, label: "Sayago" },
    { value: 71, label: "Marconi" },
    { value: 72, label: "Belvedere" },
    { value: 73, label: "Casabo" },
    { value: 74, label: "Casabo Pajas Blancas" },
    { value: 75, label: "Cerro" },
    { value: 76, label: "La Teja" },
    { value: 77, label: "Nuevo París" },
    { value: 78, label: "Paso de la Arena" },
    { value: 79, label: "Tres Ombues Pblo Victoria" },
    { value: 80, label: "La Paloma Tomkinson" },
    { value: 81, label: "Pajas Blancas" },
    { value: 343, label: "Golf" },
    { value: 347, label: "La Caleta" },
  ],
  9: [
    { value: 83, label: "Piriapolis - Gregorio Aznares" },
    { value: 85, label: "Piriapolis - Pan de Azucar" },
    { value: 86, label: "Piriapolis - Piriápolis" },
    { value: 87, label: "Piriapolis - Beaulieu" },
    { value: 88, label: "Piriapolis - Bella Vista" },
    { value: 89, label: "Piriapolis - Centro" },
    { value: 90, label: "Piriapolis - Cerro del Toro" },
    { value: 91, label: "Piriapolis - Cerro San Antonio" },
    { value: 92, label: "Piriapolis - Fuente Venus" },
    { value: 94, label: "Piriapolis - Los Ángeles" },
    { value: 95, label: "Piriapolis - Playa Grande" },
    { value: 102, label: "Piriapolis - Punta Fría" },
    { value: 104, label: "Piriapolis - Rinconada" },
    { value: 2229, label: "Piriapolis - Barrio Country" },
    { value: 2230, label: "Piriapolis - Barrio la Falda" },
    { value: 2231, label: "Piriapolis - Beaullieu" },
    { value: 2232, label: "Piriapolis - Castillo de Piria" },
    { value: 2233, label: "Piriapolis - La Cascada" },
    { value: 2234, label: "Piriapolis - La Gloria" },
    { value: 2235, label: "Piriapolis - Centro Comercial" },
    { value: 2236, label: "Piriapolis - Zona Hotel Argentino" },
    { value: 101, label: "Piriapolis - Punta Colorada" },
    { value: 93, label: "Las Flores" },
    { value: 96, label: "Playa Hermosa" },
    { value: 97, label: "Playa Verde" },
    { value: 99, label: "Proa del Mar" },
    { value: 103, label: "Punta Negra" },
    { value: 105, label: "San Francisco" },
    { value: 106, label: "Solís" },
    { value: 344, label: "Punta Ballena - Solanas" },
    { value: 107, label: "Punta Ballena - Portezuelo" },
    { value: 119, label: "Punta Ballena - Lagunas del Diario" },
    { value: 129, label: "Punta Ballena - Punta Ballen2a" },
    { value: 2237, label: "Punta Ballena - Bahia del Pinar" },
    { value: 2238, label: "Punta Ballena - Chihuahua" },
    { value: 2239, label: "Punta Ballena - Club del Lago" },
    { value: 2240, label: "Punta Ballena - El Pejerrey" },
    { value: 2241, label: "Punta Ballena - La Pataia" },
    { value: 2242, label: "Punta Ballena - Laguna del Diario" },
    { value: 2243, label: "Punta Ballena - Laguna del Sauce" },
    { value: 2244, label: "Punta Ballena - Las Cumbres" },
    { value: 2245, label: "Punta Ballena - Ocean Park" },
    { value: 2246, label: "Punta Ballena - Playa las Grutas" },
    { value: 2247, label: "Punta Ballena - Portezuelo Bosque" },
    { value: 2248, label: "Punta Ballena - Punta del Chileno" },
    { value: 2249, label: "Punta Ballena - Rinconada Alta" },
    { value: 2250, label: "Punta Ballena - Santa Hilda" },
    { value: 2251, label: "Punta Ballena - Sauce de Portezuelo" },
    { value: 2252, label: "Punta Ballena - Tio Tom" },
    { value: 110, label: "Punta del Este - Arcobaleno" },
    { value: 111, label: "Punta del Este - Barrio Córdoba" },
    { value: 112, label: "Punta del Este - Beverly Hills" },
    { value: 113, label: "Punta del Este - Cantegril" },
    { value: 115, label: "Punta del Este - Golf" },
    { value: 120, label: "Punta del Este - Las Delicias" },
    { value: 124, label: "Punta del Este - Península" },
    { value: 125, label: "Punta del Este - Pinares" },
    { value: 126, label: "Punta del Este - Playa Brava" },
    { value: 127, label: "Punta del Este - Playa Mansa" },
    { value: 128, label: "Punta del Este - Puerto" },
    { value: 131, label: "Punta del Este - Punta Shopping" },
    { value: 132, label: "Punta del Este - Rincón del Indio" },
    { value: 133, label: "Punta del Este - Roosevelt" },
    { value: 134, label: "Punta del Este - San Rafael" },
    { value: 2258, label: "Punta del Este - Playa Mansa LasDelicias" },
    { value: 2259, label: "Punta del Este - Playa Mansa Pinares" },
    { value: 2260, label: "Punta del Este - Zona El Golf" },
    { value: 2261, label: "Punta del Este - Zona Roosevelt" },
    { value: 117, label: "La Barra" },
    { value: 118, label: "La Barra - La Pastora" },
    { value: 121, label: "La Barra - Lugano" },
    { value: 122, label: "La Barra - Manantiales" },
    { value: 123, label: "La Barra - Montoya" },
    { value: 130, label: "La Barra - Punta Piedras" },
    { value: 2168, label: "La Barra - Balneario Buenos Aires" },
    { value: 2186, label: "Jose Ignacio - Arenas de José Ignacio" },
    { value: 2187, label: "Jose Ignacio - Edén Rock" },
    { value: 2188, label: "Jose Ignacio - El Caracol Costa Bonita" },
    { value: 2189, label: "Jose Ignacio - Estrella de Mar" },
    { value: 2191, label: "Jose Ignacio - La Juanita" },
    { value: 2192, label: "Jose Ignacio - Laguna de Jose Ignacio" },
    { value: 2193, label: "Jose Ignacio - Laguna Garzón" },
    { value: 2194, label: "Jose Ignacio - Las Garzas" },
    { value: 2195, label: "Jose Ignacio - Pueblo Garzón" },
    { value: 2196, label: "Jose Ignacio - San Sebastián" },
    { value: 2197, label: "Jose Ignacio - San Vicente" },
    { value: 2198, label: "Jose Ignacio - Santa Isabel" },
    { value: 2199, label: "Jose Ignacio - Santa Monica" },
    { value: 2200, label: "Jose Ignacio - Santa Rita" },
    { value: 301, label: "Jose Ignacio - Las Garzas" },
    { value: 657, label: "Jose Ignacio - Laguna Garzón" },
    { value: 82, label: "Aigua" },
    { value: 84, label: "Maldonado" },
    { value: 135, label: "San Carlos" },
    { value: 344, label: "Solanas" },
  ],
  2: [
    { value: 136, label: "Atlántida" },
    { value: 137, label: "Balneario Argentino" },
    { value: 138, label: "Barra de Carrasco" },
    { value: 139, label: "Bello Horizonte" },
    { value: 140, label: "Canelones" },
    { value: 141, label: "Ciudad de la Costa" },
    { value: 142, label: "Colinas de Solymar" },
    { value: 143, label: "Costa Azul" },
    { value: 144, label: "Cuchilla Alta" },
    { value: 145, label: "El Bosque" },
    { value: 146, label: "El Pinar" },
    { value: 147, label: "Empalme Olmos" },
    { value: 148, label: "Fortín de Santa Rosa" },
    { value: 149, label: "Guazú - Virá" },
    { value: 150, label: "Jaureguiberry" },
    { value: 151, label: "La Floresta" },
    { value: 152, label: "La Paz" },
    { value: 153, label: "La Tuna" },
    { value: 154, label: "Lagomar" },
    { value: 155, label: "Las Piedras" },
    { value: 156, label: "Las Toscas" },
    { value: 157, label: "Lomas de Solymar" },
    { value: 158, label: "Los Cerrillos" },
    { value: 159, label: "Los Titanes" },
    { value: 160, label: "Marindia" },
    { value: 161, label: "Médanos de Solymar" },
    { value: 162, label: "Migues" },
    { value: 163, label: "Montes de Solymar" },
    { value: 164, label: "Neptunia" },
    { value: 165, label: "Pando" },
    { value: 166, label: "Parque de Solymar" },
    { value: 167, label: "Parque del Plata" },
    { value: 168, label: "Pinamar" },
    { value: 169, label: "Pinares de Solymar" },
    { value: 170, label: "Progreso" },
    { value: 171, label: "Salinas" },
    { value: 172, label: "San Antonio (Uyca)" },
    { value: 173, label: "San Cristóbal" },
    { value: 174, label: "San Jacinto" },
    { value: 175, label: "San Luis" },
    { value: 176, label: "San Ramón" },
    { value: 177, label: "Santa Ana" },
    { value: 178, label: "Santa Lucía" },
    { value: 179, label: "Santa Lucía del Este" },
    { value: 180, label: "Santa Rosa" },
    { value: 181, label: "Sauce" },
    { value: 182, label: "Shangrilá" },
    { value: 183, label: "Solymar" },
    { value: 184, label: "Tala" },
    { value: 185, label: "Toledo" },
    { value: 186, label: "Villa Argentina" },
    { value: 187, label: "Barrios Privados" },
    { value: 345, label: "San José de Carrasco" },
    { value: 355, label: "Colonia Nicolich" },
  ],
  1: [
    { value: 188, label: "Artigas" },
    { value: 189, label: "Baltasar Brum" },
    { value: 190, label: "Bella Unión" },
    { value: 191, label: "Bernabé Rivera" },
    { value: 192, label: "Cuaro" },
    { value: 193, label: "Javier de Viana" },
    { value: 194, label: "Pintadito" },
    { value: 195, label: "Tomás Gomensoro" },
    { value: 196, label: "Topador" },
  ],
  3: [
    { value: 197, label: "Aceguá" },
    { value: 198, label: "Cerro de las Cuentas" },
    { value: 199, label: "Fraile Muerto" },
    { value: 200, label: "Isidoro Noblía" },
    { value: 201, label: "Melo" },
    { value: 202, label: "Río Branco" },
    { value: 203, label: "Tres Islas" },
  ],
  4: [
    { value: 204, label: "Arrivillaga" },
    { value: 205, label: "Artilleros" },
    { value: 206, label: "Barker" },
    { value: 207, label: "Blanca Arena" },
    { value: 208, label: "Boca del Rosario" },
    { value: 209, label: "Brisas del Plata" },
    { value: 210, label: "Carmelo" },
    { value: 211, label: "Cerros de San Juan" },
    { value: 212, label: "Colonia Cosmopolita" },
    { value: 213, label: "Colonia del Sacramnto" },
    { value: 214, label: "Colonia Mguelete" },
    { value: 215, label: "Colonia Valdense" },
    { value: 216, label: "Conchillas" },
    { value: 217, label: "Cufré" },
    { value: 218, label: "El semillero" },
    { value: 219, label: "El Solado" },
    { value: 220, label: "Estanzuela" },
    { value: 221, label: "Juan Lacaze" },
    { value: 222, label: "La Paz (Uyco)" },
    { value: 223, label: "Los Pinos" },
    { value: 224, label: "Nueva Helvecia" },
    { value: 225, label: "Nueva Palmira" },
    { value: 226, label: "Ombúes de Lavalle" },
    { value: 227, label: "Paraje Minuano" },
    { value: 228, label: "Paso Minuano" },
    { value: 229, label: "Paso Antolín" },
    { value: 230, label: "Pastoreo" },
    { value: 231, label: "Playa Azul" },
    { value: 232, label: "Playa Britópolis" },
    { value: 233, label: "Playa Parant" },
    { value: 234, label: "Puerto Inglés" },
    { value: 235, label: "Rosario" },
    { value: 236, label: "Santa Regina" },
    { value: 237, label: "Tarariras" },
  ],
  5: [
    { value: 238, label: "Durazno" },
    { value: 239, label: "San Jorge" },
    { value: 240, label: "Santa Bernardita" },
  ],
  6: [
    { value: 241, label: "San Gregorio Carrio" },
    { value: 242, label: "Trinidad" },
  ],
  7: [
    { value: 243, label: "25 de Agosto" },
    { value: 244, label: "Cardal" },
    { value: 245, label: "Cerro Colorado (FI)" },
    { value: 246, label: "Florida" },
    { value: 247, label: "Fray Marcos" },
    { value: 248, label: "Independencia" },
    { value: 249, label: "La Cruz" },
    { value: 250, label: "Pintado" },
    { value: 251, label: "Sarandí Grande" },
  ],
  8: [
    { value: 252, label: "Colón" },
    { value: 253, label: "Illescas" },
    { value: 254, label: "José Pedro Varela" },
    { value: 255, label: "La Mariscala" },
    { value: 256, label: "María Albina" },
    { value: 257, label: "Minas" },
    { value: 258, label: "Piraraja" },
    { value: 259, label: "Solís de Mataojo" },
    { value: 260, label: "Zapican" },
    { value: 346, label: "Villa del Cerro" },
  ],
  11: [
    { value: 261, label: "Chapicuy" },
    { value: 262, label: "Guaviyú" },
    { value: 263, label: "Paysandú" },
    { value: 264, label: "Piedra Sola" },
    { value: 265, label: "Quebracho" },
  ],
  12: [
    { value: 266, label: "Algorta" },
    { value: 267, label: "Andresito" },
    { value: 268, label: "Barrio Anglo" },
    { value: 269, label: "Cardozo" },
    { value: 270, label: "Carlos Reyles" },
    { value: 271, label: "Fray Bentos" },
    { value: 272, label: "General Borges" },
    { value: 273, label: "Grecco" },
    { value: 274, label: "Las Cañas" },
    { value: 275, label: "Nuevo Berlín" },
    { value: 276, label: "Pueblo Orgoroso" },
    { value: 277, label: "Rincón del Bonete" },
    { value: 278, label: "San Javier" },
    { value: 279, label: "Villa María" },
    { value: 280, label: "Young" },
  ],
  13: [
    { value: 281, label: "La Pedrera (Rv)" },
    { value: 282, label: "Laguñón" },
    { value: 283, label: "Mandubí" },
    { value: 284, label: "Masoller" },
    { value: 285, label: "Minas de Corrales" },
    { value: 286, label: "Paso Campamento" },
    { value: 287, label: "Rivera" },
    { value: 288, label: "Santa Teresa" },
    { value: 289, label: "Traqueras" },
  ],
  14: [
    { value: 2253, label: "Punta del Diablo - Centro" },
    { value: 2254, label: "Punta del Diablo - Playa de la Viuda" },
    { value: 2255, label: "Punta del Diablo - Playa del Rivero" },
    { value: 2256, label: "Punta del Diablo - Zona el Bosque" },
    { value: 2257, label: "Punta del Diablo - Zona Terminal" },
    { value: 302, label: "Punta del Diablo - Punta del Diablo" },
    { value: 649, label: "La Pedrera - Punta Rubia" },
    { value: 2217, label: "La Pedrera - Santa Isabel de la Pedrera   " },
    { value: 2218, label: "La Pedrera - Barracas de la Pedrera" },
    { value: 2219, label: "La Pedrera - Centro" },
    { value: 2220, label: "La Pedrera - Diamantes de la Pedrera" },
    { value: 2221, label: "La Pedrera - Playa del Barco" },
    { value: 2222, label: "La Pedrera - Playa Desplayado" },
    { value: 2223, label: "La Pedrera - Pueblo Nuevo" },
    { value: 2224, label: "La Pedrera - San Antonio" },
    { value: 2225, label: "La Pedrera - San Sebastián de la Pedrera" },
    { value: 2226, label: "La Pedrera - Tajamares de la Pedrera" },
    { value: 651, label: "La Paloma - Santa María De Rocha" },
    { value: 2203, label: "La Paloma - Barrio Country" },
    { value: 2204, label: "La Paloma - Barrio Parque" },
    { value: 2205, label: "La Paloma - Casco Viejo" },
    { value: 2206, label: "La Paloma - Centro" },
    { value: 2207, label: "La Paloma - El Cabito" },
    { value: 2208, label: "La Paloma - Laguna de Rocha" },
    { value: 2209, label: "La Paloma - Los Botes" },
    { value: 2210, label: "La Paloma - Playa Anaconda" },
    { value: 2211, label: "La Paloma - Playa Bahía" },
    { value: 2212, label: "La Paloma - Playa la Balconada" },
    { value: 2213, label: "La Paloma - Playa Serena y Solari" },
    { value: 2214, label: "La Paloma - Rincón del Rosario" },
    { value: 2215, label: "La Paloma - Santa María de Rocha" },
    { value: 2216, label: "La Paloma - La Riviera" },
    { value: 644, label: "La Paloma - Antoniópolis" },
    { value: 645, label: "La Paloma - Arachania" },
    { value: 646, label: "La Paloma - Costa Azul" },
    { value: 647, label: "La Paloma - La Aguada" },
    { value: 648, label: "Oceanía Del Polonio" },
    { value: 2181, label: "Cabo Polonio" },
    { value: 2183, label: "Cabo Polonio - Playa la Calavera (Norte)" },
    { value: 2184, label: "Cabo Polonio - Playa Sur" },
    { value: 2179, label: "Barra del Chuy - Balneario la Alborada" },
    { value: 2180, label: "Barra del Chuy - Barra do Chui Brasil" },
    { value: 2175, label: "Barra del Chuy - Balneario Puimayen" },
    { value: 2176, label: "Barra del Chuy - Barra del Chuy" },
    { value: 295, label: "Barra del Chuy - Chuy" },
    { value: 290, label: "Aguas Dulces" },
    { value: 291, label: "Barra de Valizas" },
    { value: 650, label: "Valizas" },
    { value: 294, label: "Castillos" },
    { value: 296, label: "Dieciocho de Julio (Ro)" },
    { value: 303, label: "Rocha" },
    { value: 656, label: "Lascano" },
    { value: 297, label: "Vuelta del Palmar - El Palmar" },
    { value: 653, label: "La Esmeralda" },
    { value: 655, label: "La Coronilla" },
  ],
  15: [
    { value: 304, label: "Arenitas Blancas" },
    { value: 305, label: "Artaux" },
    { value: 306, label: "Belén" },
    { value: 307, label: "Colonia 18 de Julio" },
    { value: 308, label: "Constitución" },
    { value: 309, label: "Salto" },
    { value: 310, label: "Termas del Arapey" },
    { value: 311, label: "Termas del Daymán" },
  ],
  16: [
    { value: 312, label: "Boca del Cufré" },
    { value: 313, label: "Delta del Tigre" },
    { value: 314, label: "Ecilda Paullier" },
    { value: 315, label: "Ituzaingó" },
    { value: 316, label: "Libertad" },
    { value: 317, label: "Playa Pascual" },
    { value: 318, label: "San José" },
    { value: 319, label: "San José de Mayo" },
    { value: 320, label: "Scavino" },
    { value: 321, label: "Villa Rodríguez" },
  ],
  17: [
    { value: 322, label: "Canada Nieto" },
    { value: 323, label: "Cardona" },
    { value: 324, label: "Dolores" },
    { value: 325, label: "Egana" },
    { value: 326, label: "Florencio Sánchez" },
    { value: 327, label: "José Enrique Rodó" },
    { value: 328, label: "Mercedes" },
    { value: 329, label: "Palmitas" },
    { value: 330, label: "Risso" },
    { value: 331, label: "Santa Catalina" },
  ],
  18: [
    { value: 332, label: "Clara" },
    { value: 333, label: "Paso Bonilla" },
    { value: 334, label: "Paso de los Toros" },
    { value: 335, label: "Paso del Cerro" },
    { value: 336, label: "San Gregorio de Polanco" },
    { value: 337, label: "Tacuarembó" },
    { value: 338, label: "Villa Ansina" },
  ],
  19: [
    { value: 339, label: "Isla Patrulla" },
    { value: 340, label: "Treinta y Tres" },
    { value: 341, label: "Tupambae" },
    { value: 342, label: "Vergara" },
  ],
};
